import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, X } from 'lucide-react';
interface RepModalProps {
  isOpen: boolean;
  repName: string;
  role: string;
  onSave: (rate: number) => void;
  onCancel: () => void;
}
export function RepModal({
  isOpen,
  repName,
  role,
  onSave,
  onCancel
}: RepModalProps) {
  const [percentage, setPercentage] = useState<string>('');
  useEffect(() => {
    if (isOpen) {
      setPercentage('');
    }
  }, [isOpen]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const rate = parseFloat(percentage);
    if (!isNaN(rate) && rate >= 0 && rate <= 100) {
      onSave(rate / 100); // Convert to decimal
    }
  };
  return <AnimatePresence data-id="element-198">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-199">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="w-full max-w-md overflow-hidden bg-white rounded-xl shadow-2xl" data-id="element-200">
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-slate-50/50" data-id="element-201">
              <div className="flex items-center gap-2 text-slate-800" data-id="element-202">
                <Users className="w-5 h-5 text-indigo-600" data-id="element-203" />
                <h3 className="font-semibold" data-id="element-204">New {role} Detected</h3>
              </div>
              <button onClick={onCancel} className="p-1 text-slate-400 transition-colors rounded-md hover:bg-slate-200 hover:text-slate-600" data-id="element-205">
                <X className="w-5 h-5" data-id="element-206" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-6" data-id="element-207">
              <p className="mb-6 text-sm text-slate-600" data-id="element-208">
                <strong data-id="element-209">{repName}</strong> is not in the system yet. Please
                enter their default commission percentage to continue saving
                this job.
              </p>

              <div className="mb-6" data-id="element-210">
                <label htmlFor="percentage" className="block mb-2 text-sm font-medium text-slate-700" data-id="element-211">
                  Commission Percentage
                </label>
                <div className="relative" data-id="element-212">
                  <input type="number" id="percentage" step="0.01" min="0" max="100" required value={percentage} onChange={e => setPercentage(e.target.value)} className="w-full py-2.5 pl-4 pr-8 text-slate-900 bg-white border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all" placeholder="e.g. 10" autoFocus data-id="element-213" />
                  <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-slate-500 pointer-events-none" data-id="element-214">
                    %
                  </span>
                </div>
              </div>

              <div className="flex justify-end gap-3" data-id="element-215">
                <button type="button" onClick={onCancel} className="px-4 py-2 text-sm font-medium text-slate-700 transition-colors bg-white border border-slate-300 rounded-lg hover:bg-slate-50" data-id="element-216">
                  Cancel
                </button>
                <button type="submit" disabled={!percentage} className="px-4 py-2 text-sm font-medium text-white transition-colors bg-indigo-600 rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-217">
                  Save & Continue
                </button>
              </div>
            </form>
          </motion.div>
        </div>}
    </AnimatePresence>;
}